var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-box"},[_c('MglMap',_vm._b({attrs:{"access-token":_vm.accessToken,"map-style":_vm.mapStyle}},'MglMap',_vm.mBoxOptions,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }